import { useOnlineStatus } from "@/hooks/use-online-status";
import { WifiOff } from "lucide-react";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export function OfflineIndicator() {
  const isOnline = useOnlineStatus();
  const [shouldRender, setShouldRender] = useState(!isOnline);

  useEffect(() => {
    if (!isOnline) {
      setShouldRender(true);
    } else {
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-50",
        isOnline ? "animate-slide-up-and-fade" : "animate-slide-down-and-fade"
      )}
      aria-live="assertive"
    >
      <div className="bg-gradient-to-r from-red-600 to-orange-500 text-white font-semibold flex items-center justify-center p-3 shadow-lg">
        <WifiOff className="w-5 h-5 mr-3" />
        <span>
          You are currently offline. Please check your network connection.
        </span>
      </div>
    </div>
  );
}
